// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Products_pageContent__gpuUh"};